export const trackLead = () => {
    if (typeof window !== 'undefined') {
        if (window.hasOwnProperty('fbq')) {
            // @ts-ignore
            window.fbq('track', 'Lead');
        }
        if (window.hasOwnProperty('gtag')) {
            // @ts-ignore
            window.gtag('event', 'generate_lead', {
                currency: 'BRL',
                value: 1.0
            });
        }
    }
};

export const trackWhatsAppClick = () => {
    if (typeof window !== 'undefined') {
        if (window.hasOwnProperty('fbq')) {
            // @ts-ignore
            window.fbq('trackCustom', 'WhatsAppClick');
        }
        if (window.hasOwnProperty('gtag')) {
            // @ts-ignore
            window.gtag('event', 'click_whatsapp');
        }
    }
};
